import {
  Box,
  Breakpoint,
  Color,
  Display,
  FlexDirection,
  Image,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import React from 'react'

import LifestyleShootImage from '../assets/lifestyle-shoot.png'

type RafActionCardProps = {
  children: React.ReactNode
  imageTestId: string
  testId: string
}

const RafCampaignContainer = withCitrusTheme('article', (theme) => ({
  backgroundColor: theme.color(Color.White),
  border: `1px solid ${theme.color(Color.ColdGrey_100)}`,
  borderRadius: '6px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  width: '100%',
  [`@media (min-width: ${Breakpoint.Medium})`]: {
    flexDirection: 'row',
  },
}))

const DesktopImageContainer = withCitrusTheme(Box, () => ({
  display: 'none',
  flexShrink: 0,
  lineHeight: 0,
  [`@media (min-width: ${Breakpoint.Medium})`]: {
    display: 'block',
  },
}))

export function RafActionCard({ children, imageTestId, testId }: RafActionCardProps) {
  return (
    <RafCampaignContainer data-testid={testId}>
      <Box
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        flexGrow={1}
        gap={4}
        minWidth="0"
        paddingH={4}
        paddingV={4}
        width="100%"
      >
        {children}
      </Box>
      <DesktopImageContainer data-testid={imageTestId}>
        <Image
          alt=""
          height="100%"
          src={LifestyleShootImage}
          style={{ display: 'block' }}
          width="auto"
        />
      </DesktopImageContainer>
    </RafCampaignContainer>
  )
}
